import { v4 as uuid } from 'uuid';

const PillsSkeleton = () => {
  const generateTabs = () => {
    const list = Array(5).fill('.');

    return list.map(list => {
      return (
        <div key={uuid()} className={'itemHeader'}>
          <div className="fullSkeleton" />
        </div>
      );
    });
  };
  const generateProperties = () => {
    return (
      <>
        <div className="containerSelect">
          <div className="fullSkeleton" />
        </div>
        <div className="containerSelect">
          <div className="fullSkeleton" />
        </div>
        <div className="containerSelect">
          <div className="fullSkeleton" />
        </div>
      </>
    );
  };
  return (
    <>
      <div className="generalTabsContainer">
        <div className="headerTabs">{generateTabs()}</div>
        <div className="containerProperties">
          <div className="h-24 w-176">
            <div className="fullSkeleton" />
          </div>
          <div className="containterProperties">
            <div className="h-20 w-40 mr-8">
              <div className="fullSkeleton" />
            </div>
            <div className="h-20 w-40 mr-8">
              <div className="fullSkeleton" />
            </div>
            {generateProperties()}
          </div>
        </div>
      </div>
    </>
  );
};
export default PillsSkeleton;
